/**
 * Created by Jiu Chen on 01/11/2019.
 * Description:
 *
 * ------ maintenance history ------
 * 2019/8/28  Bowen  change relationship type
 */

import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';

import { RelationshipTypeService } from '@tamalelibs/services/relationshipType.service';
import { RelationshipTypeActionTypes } from '../actions/relationship-type.actions';
import { RelationshipType } from '@tamalelibs/models/relationship-type.model';
import { ValidRelationshipType } from '@tamalelibs/models/valid-relationship-type.model';

@Injectable()
export class RelationshipTypeEffects {

    constructor(
        private _actions$: Actions,
        private _relationshipTypeService: RelationshipTypeService,
    ) { }

    initializeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(RelationshipTypeActionTypes.INITIALIZE),
        switchMap(() => {
            return this._relationshipTypeService.getAll().pipe(
                map(response => response['relationship-type-list']),
                map(response => {
                    const relationshipTypeList = response.map(element => RelationshipType.parse(element));
                    return {
                        type: RelationshipTypeActionTypes.INITIALIZE_SUCCESS,
                        payload: relationshipTypeList
                    };
                })
            );
        }),
        catchError(err => {
            return of({
                type: RelationshipTypeActionTypes.INITIALIZE_FAILED,
                payload: err.message
            });
        })
    ));

    getValidRelationshipEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(RelationshipTypeActionTypes.GETVALIDRELATIONSHIP),
        switchMap(() => {
            return this._relationshipTypeService.getAllValidRelationship().pipe(
                map(response => response['valid-relationships']),
                map(response => {
                    const validRelationshipTypeList = response.map(element => ValidRelationshipType.parse(element));
                    return {
                        type: RelationshipTypeActionTypes.GETVALIDRELATIONSHIP_SUCCESS,
                        payload: validRelationshipTypeList
                    };
                })
            );
        }),
        catchError(err => {
            return of({
                type: RelationshipTypeActionTypes.GETVALIDRELATIONSHIP_FAILED,
                payload: err.message
            });
        })
    ));

    deleteRelationshipTypeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(RelationshipTypeActionTypes.DELETE_RELATIONSHIP_TYPE),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) =>
            this._relationshipTypeService.deleteOneVaildRelationship(payload.relationshipId)
                .pipe(
                    map(response => ({
                        type: RelationshipTypeActionTypes.DELETE_RELATIONSHIP_TYPE_SUCCESS,
                        payload: {
                            id: payload.relationshipId,
                        }
                    })),
                    catchError(err => {
                        return of({
                            type: RelationshipTypeActionTypes.DELETE_RELATIONSHIP_TYPE_FAILED,
                            payload: err
                        });
                    })
                )
        )
    ));

    newRelationshipTypeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(RelationshipTypeActionTypes.CREATE_VALID_RELATIONSHIP_TYPE),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._relationshipTypeService.createOneValidRelationship(payload.parent.id, payload.child.id, payload.relationshipType.id, payload.reciprocal.id)
            .pipe(
                map(response => ({
                    type: RelationshipTypeActionTypes.CREATE_VALID_RELATIONSHIP_TYPE_SUCCESS,
                    payload: ValidRelationshipType.parse(response)
                })),
                catchError(err => {
                    return of({
                        type: RelationshipTypeActionTypes.CREATE_VALID_RELATIONSHIP_TYPE_FAILED,
                        payload: err
                    });
                })
            )
        )
    ));

    editRelationshipTypeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(RelationshipTypeActionTypes.EDIT_RELATIONSHIP_TYPE),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._relationshipTypeService.editRelationshipType(payload.newRelationshipTypeName, payload.relationshipTypeId)
            .pipe(
                map(response => ({
                    type: RelationshipTypeActionTypes.EDIT_RELATIONSHIP_TYPE_SUCCESS,
                    payload: {
                        oldRelationshipTypeName: payload.oldRelationshipTypeName,
                        oldRelationshipTypeId: payload.oldRelationshipTypeId,
                        newRelationshipTypeName: payload.newRelationshipTypeName,
                        relationshipTypeId: payload.relationshipTypeId,
                        newRelationshipTypeId: response.id,
                    }
                })),
                catchError(err => {
                    return of({
                        type: RelationshipTypeActionTypes.EDIT_RELATIONSHIP_TYPE_FAILED,
                        payload: err
                    });
                })
            )
        )
    ));

}
